import { Link } from "react-router-dom";
import logoImg from "@/assets/logo.png";
import { ShieldCheck, HeartHandshake, Database } from "lucide-react";

export function PublicFooter() {
  return (
    <footer className="border-t border-[#e6e6e6] bg-[#f6f5f4] text-[#31302e]">
      <div className="mx-auto max-w-6xl px-4 py-12 sm:px-6">
        <div className="grid gap-8 md:grid-cols-4">
          {/* Hospital Identity */}
          <div className="space-y-3 md:col-span-2">
            <div className="flex items-center gap-2.5">
              <img
                src={logoImg}
                alt="EKSUTH Logo"
                className="h-9 w-9 rounded-full border border-[#e6e6e6] object-contain shadow-xs"
              />
              <div>
                <h3 className="text-[15px] font-semibold text-[#000000]">
                  Ekiti State University Teaching Hospital
                </h3>
                <p className="text-xs text-[#615d59]">
                  Department of Medical Microbiology & Parasitology
                </p>
              </div>
            </div>
            <p className="text-[13px] text-[#615d59] leading-relaxed max-w-md">
              A clinical decision support and hospital surveillance system establishing cumulative
              antibiograms according to CLSI M39 standards, digitizing bench daybooks, and guiding
              empiric antimicrobial therapy in Ado-Ekiti, Nigeria.
            </p>
            <div className="flex items-center gap-4 text-xs text-[#a39e98] pt-1">
              <span className="flex items-center gap-1">
                <ShieldCheck className="h-3.5 w-3.5 text-[#1aae39]" /> CLSI M39
              </span>
              <span className="flex items-center gap-1">
                <Database className="h-3.5 w-3.5 text-[#0075de]" /> WHONET Export
              </span>
              <span className="flex items-center gap-1">
                <HeartHandshake className="h-3.5 w-3.5 text-[#dd5b00]" /> Hospital Stewardship
              </span>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-2.5">
            <h4 className="text-xs font-semibold uppercase tracking-wider text-[#a39e98]">
              Platform Navigation
            </h4>
            <ul className="space-y-2 text-[13px] text-[#615d59]">
              <li>
                <Link to="/" className="hover:text-[#000000] transition-colors">
                  Overview
                </Link>
              </li>
              <li>
                <Link to="/docs" className="hover:text-[#000000] transition-colors">
                  Documentation
                </Link>
              </li>
              <li>
                <Link to="/docs#appendix-a" className="hover:text-[#000000] transition-colors">
                  Appendix A: Antibiotics
                </Link>
              </li>
              <li>
                <Link to="/docs#appendix-b" className="hover:text-[#000000] transition-colors">
                  Appendix B: Organisms
                </Link>
              </li>
              <li>
                <Link to="/docs#appendix-c" className="hover:text-[#000000] transition-colors">
                  Appendix C: Wards & Specimens
                </Link>
              </li>
            </ul>
          </div>

          {/* Staff Access */}
          <div className="space-y-2.5">
            <h4 className="text-xs font-semibold uppercase tracking-wider text-[#a39e98]">
              Staff & Entry
            </h4>
            <ul className="space-y-2 text-[13px] text-[#615d59]">
              <li>
                <Link to="/login" className="hover:text-[#000000] transition-colors">
                  Staff Sign In
                </Link>
              </li>
              <li>
                <Link to="/signup" className="hover:text-[#000000] transition-colors">
                  Volunteer Sign Up
                </Link>
              </li>
              <li>
                <Link to="/workbench" className="hover:text-[#000000] transition-colors">
                  Volunteer Workbench
                </Link>
              </li>
              <li>
                <Link to="/dashboard" className="hover:text-[#000000] transition-colors">
                  Surveillance Dashboard
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom copyright / location */}
        <div className="mt-10 border-t border-[#e6e6e6] pt-6 flex flex-col sm:flex-row items-center justify-between text-xs text-[#a39e98] gap-3">
          <p>
            &copy; {new Date().getFullYear()} Ekiti State University Teaching Hospital (EKSUTH).
          </p>
          <p>
            Hospital Road, Ado-Ekiti, Nigeria &middot; Offline-First Hospital Node
          </p>
        </div>
      </div>
    </footer>
  );
}
